import { AppState } from '../types';

/** Select current application state */
export function selectApp({ app }: { app: AppState }) {
  return app;
}
